import * as React from "react";
import { ActTagViewForPcGrid } from "./styles";
export const ActTagViewForPc = (props) => {
    const { actTags } = props;
    return (React.createElement(ActTagViewForPcGrid, null, (actTags || []).map((item, index) => (React.createElement("img", { key: `${item}${index}`, src: item })))));
};
